document.addEventListener("DOMContentLoaded", function() {

    // swiper detail - foto nemovitosti (detail-4)
    //============================================
    (function () {
        let swiperSelector = document.querySelector('[data-detail-gallery]');
        if(typeof(swiperSelector) === 'undefined' || swiperSelector === null)
            return;

        let swiperDetail = new Swiper(swiperSelector, {
            lazy:  {
                loadPrevNext: true
            },
            loop: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            centeredSlides: true,
            slidesPerView: 2,
            spaceBetween: 4,
            breakpoints: {
                320: {
                    slidesPerView: 1
                },
                992: {
                    slidesPerView: 1.6,
                },
                2050: {
                    slidesPerView: 2.6,
                },
                3050: {
                    slidesPerView: 3.6,
                },
            }
        });
    }());

    initGalleryOnClones();
    function initGalleryOnClones() {
        // Swiper s loop:true vytváří klonované slidy (.swiper-slide-duplicate). Ty nejsou
        // součástí hlavní galerie – init/gallery.js ji navázal na reálné slidy ještě před klonováním.
        // Klik na klon proto přesměrujeme na odpovídající reálný slide (mapujeme přes
        // data-swiper-slide-index) → otevře se kompletní galerie na správné pozici,
        // místo dřívější neúplné galerie složené jen z klonů.
        let gallery = document.querySelector('[data-detail-gallery]');
        if (typeof(gallery) === 'undefined' || gallery === null)
            return;

        gallery.querySelectorAll('.swiper-slide-duplicate .JS-lightgallery-item').forEach(function (cloneItem) {
            cloneItem.addEventListener('click', function (event) {
                let slide = cloneItem.closest('.swiper-slide');
                if (slide === null)
                    return;

                let slideIndex = slide.getAttribute('data-swiper-slide-index');
                let realItem = gallery.querySelector('.swiper-slide:not(.swiper-slide-duplicate)[data-swiper-slide-index="' + slideIndex + '"] .JS-lightgallery-item');
                if (realItem === null)
                    return;

                event.preventDefault();
                realItem.click();
            });
        });
    }

    const showMapButton = document.querySelector(".JS-show-map");
    if (showMapButton) {
        showMapButton.addEventListener("click", function () {
            const mapDetailElement = document.querySelector(".estateDetail-map");
            if (mapDetailElement) {
                mapDetailElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                });
            } else {
                console.error('Na stránce neexistuje mapa se selectorem ".estateDetail-map". Odstraň tlačítko pro scrollování nebo přidej mapu na stránku.');
            }
            const placeholderShowMapButton = document.querySelector('[data-detail-map-button]');
            if (placeholderShowMapButton) {
                placeholderShowMapButton.dispatchEvent(new MouseEvent('click'));
            }
        })
    }
});